module.exports = __webpack_public_path__ + "assets/assets/images/about/legal.5aaa579f.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/about/legal.png
// module id = 545
// module chunks = 0